import "./index.scss";
import IconButton from "../../../../components/IconButton";
import { IconX } from "../../../../icons";
import Input from "../../../../components/Input";

interface ModalMessageProps {
  status: boolean;
  text: string;
  monthAndYear: any;
  setMonthAndYear: any;
  onClickCancel: (event?: any) => void;
  onClickConfirm: (event?: any) => void;
}

export function ModalMessageSelectMonth({ status, text, onClickCancel, onClickConfirm, monthAndYear, setMonthAndYear }: ModalMessageProps) {
  return (
    <>
      {status && (
        <div className="container">
          <div className="modalContainer modalDeleteContainer">
            <IconButton className="iconX" icon={IconX} onClick={() => onClickCancel(!status)} />
            <h1>{text}</h1>
            <div className="modalDeleteContainerButton">
              <Input
                setValue={(event: any) => setMonthAndYear(event.target.value)}
                value={monthAndYear}
                name="date"
                label=""
                className=""
                type="month"
                placeholder="Digite o período"
              />
              <button className="btn center pointer radius font-poppins" type="button" onClick={() => onClickConfirm()}>
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
